import React from 'react';
import { Link } from 'react-router-dom';
import { DEFAULT_LOCAL_PATH } from '../../../constents';

function ComCurtainSingleMsg({
  altClas,
  item,
  selectedMsgId,
  handleShowSingleMsg,
  handleDeleteSingleMsg,
  handleFlagChange,
  close,
}) {
  const selClass = selectedMsgId === item?.msgId ? 'crtn-actv-rw' : '';
  const handleFlagClick = () => {
    const flag = item?.redFlag === '1' ? '0' : '1';
    handleFlagChange(item?.msgId, item?.type, flag);
  };
  return (
    <div>
      <div
        className={`left com-curtn-bdy-rw ${altClas} ${
          item?.unreadCl ? 'bold' : ''
        }`}
      >
        <div
          style={{ width: '90%' }}
          onClick={() =>
            handleShowSingleMsg(item?.msgId, item?.type, item?.redFlag)
          }
        >
          <div
            className={`left com-curtn-actvinactv ${selClass} ${
              item?.unreadCl ? 'crtn-unrd-rw' : ''
            }
          }`}
          >
            &nbsp;
          </div>
          <div className="left com-curtn-bdy-rw-lt">
            <span className="left com-curtn-icn">
              {item?.type === '3' ? 'CL' : 'Pt.'}
            </span>
          </div>
          <div className="left com-curtn-bdy-rw-rt">
            <>
              <span
                className="left com-curtn-frm width100"
                style={{ marginBottom: '5px' }}
              >
                From:{' '}
                <span
                  dangerouslySetInnerHTML={{
                    __html: item?.showName,
                  }}
                />
              </span>
              {item?.type !== '3' && item?.chartNo && (
                <span className="left width100">
                  &nbsp;{' '}
                  <span>
                    <span
                      className="left com-curtn-dt clear5 normal"
                      style={{ marginLeft: '44px' }}
                    >
                      Chart#: {item?.chartNo}
                      <span className="red">&nbsp;|&nbsp;</span>
                      DOB: {item?.dob}
                      {item?.mob && (
                        <>
                          <span className="red">&nbsp;|&nbsp;</span>
                          {item?.mob}
                        </>
                      )}
                    </span>
                  </span>
                </span>
              )}
              <span className="width100 fontsize13 sec-colr clear-top5">
                To:{' '}
                <span
                  dangerouslySetInnerHTML={{
                    __html: item?.toUser,
                  }}
                />
              </span>
            </>
            {item?.type !== '1' && item?.subLine && (
              <span className="left com-curtn-sbjct width100">
                <span
                  dangerouslySetInnerHTML={{
                    __html: item?.subLine
                      ? item?.subLine.replace(/\\'/g, "'")
                      : '',
                  }}
                />
              </span>
            )}
            <span className="left com-curtn-msg width100">
              {item?.type === '1' ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: item?.subLine
                      ? item?.subLine.replace(/\\'/g, "'")
                      : '',
                  }}
                />
              ) : (
                <span
                  dangerouslySetInnerHTML={{
                    __html: item?.msgLine ? item?.msgLine : '',
                  }}
                />
              )}
            </span>
            <span className="left com-curtn-dt width100">
              {item?.msgSentReceiveTime}
            </span>
            {item?.attchPatList && item?.attchPatList.length > 0 && (
              <span className="left com-curtn-dt width100">
                <span className="hide">Patient :- </span>
                {item?.attchPatList.map((patient) => (
                  <div
                    key={patient?.patientId}
                    style={{ margin: '8px 0px 0px 2px' }}
                    onClick={close}
                  >
                    <Link
                      to={`${DEFAULT_LOCAL_PATH}/patient/counNote/${patient?.patientId}`}
                    >
                      {`${patient?.pat_attach} (Chart #: ${patient?.chart_number})`}
                    </Link>
                  </div>
                ))}
              </span>
            )}
          </div>
        </div>
        <div>
          <span
            className="sndrcv-lt-dlt"
            style={{ width: '5%' }}
            onClick={() => handleDeleteSingleMsg(item?.msgId, item?.type)}
          >
            &#128465;
          </span>
          <span
            className={
              item?.redFlag === '1'
                ? 'sndrcv-lt-dlt actv-cm-flagged'
                : 'sndrcv-lt-dlt'
            }
            style={{ width: '5%' }}
            onClick={handleFlagClick}
          >
            &#9872;
          </span>
        </div>
      </div>
    </div>
  );
}

export default ComCurtainSingleMsg;
